<script setup>
defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  stateMessage: {
    type: String,
    default: '',
  },
  stateLabel: {
    type: String,
    default: 'Profile unavailable',
  },
  audienceGroup: {
    type: String,
    default: 'Affiliate',
  },
  name: {
    type: String,
    default: 'GSD Now user',
  },
});
</script>

<template>
  <div v-if="isLoading" class="profile-page_header" aria-hidden="true"></div>

  <div v-else-if="stateMessage" class="profile-page_header" role="alert">
    <p class="profile-page_audience-group">{{ stateLabel }}</p>
    <h1 class="profile-page_name">{{ stateMessage }}</h1>
  </div>

  <div v-else class="profile-page_header">
    <p v-if="audienceGroup" class="profile-page_audience-group">{{ audienceGroup }}</p>
    <h1 class="profile-page_name">{{ name }}</h1>
  </div>
</template>
